"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Eyeslash = function Eyeslash(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "EyeslashTitle EyeslashDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "EyeslashTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "EyeslashDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M12.182 7.339a4.175 4.175 0 0 1 4.174 4.174 4.07 4.07 0 0 1-.3 1.527l2.437 2.438a9.864 9.864 0 0 0 2.863-3.965c-1.444-3.665-5.009-6.26-9.182-6.26a9.72 9.72 0 0 0-3.322.583l1.803 1.803c.475-.192.985-.3 1.527-.3zM3.835 5.06l1.903 1.903.384.384A9.853 9.853 0 0 0 3 11.513c1.444 3.664 5.008 6.26 9.182 6.26a9.83 9.83 0 0 0 3.656-.701l.35.35 2.447 2.438 1.06-1.06L4.895 4l-1.06 1.06zM8.45 9.676l1.294 1.294a2.355 2.355 0 0 0-.067.543 2.5 2.5 0 0 0 2.504 2.504c.184 0 .367-.025.543-.067l1.294 1.294a4.138 4.138 0 0 1-1.837.442 4.175 4.175 0 0 1-4.174-4.173c0-.66.167-1.278.443-1.837zm3.598-.65l2.629 2.629.017-.134a2.5 2.5 0 0 0-2.505-2.504l-.141.008z"
  }));
};

Eyeslash.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Eyeslash.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Eyeslash;
exports["default"] = _default;